// App constants

import { MarketmapScripting, IMarketmapConsumerViewState } from 'src/models/marketmap/marketmap.model';

export const appName = 'Glide';

export const zIndex = {
  SearchInspector: 2,
  Calendar: 10,
  CollapseWrapperBtn: 8,
  CollapseWrapper: 9,
};

export const snackbar = {
  AUTO_HIDE_DURATION_SECS: 15 * 1000, // 15s
};

export const amountOfVisibleActions: number = 5;
/**
 * List of marketmap fields mapped and configured to their corresponding numbers
 */
export enum MarketmapFields {
  'SYMBOL' = 'Symbol',
  'LAST_PRICE' = 2,
  'INSTRUMENT_NAME' = 400,
  'NET_CHANGE' = 101,
  'PERC_NET_CHANGE' = 109,
}

/**
 * The marketmap credentials are hardcoded as of now,
 * it will be entered by user through some form/dialog form... in future
 */
export const marketmapCredentials = {
  marketmapGroup: 'AA360',
  marketmapUserId: 'aa360devtest1', // or 'aa360devserver'
  marketmapPassword: 'aa360devtest1', // or 'aa360devserver'
};

/**
 * There is issue with Array format, identified in POC, hence using Object format as response data
 */
export const marketmapOutputFormat = {
  OBJECT_FORMAT: 1,
  ARRAY_FORMAT: 2,
};

export const marketmapScripts: MarketmapScripting[] = [
  {
    scriptingElement: null,
    scriptingUrl: 'https://www.marketmapmuse.com/Scripts/jquery.min.js',
  },
  {
    scriptingElement: null,
    scriptingUrl: 'https://www.marketmapmuse.com/Scripts/jquery.signalR-2.2.0.min.js',
  },
  {
    scriptingElement: null,
    scriptingUrl: 'https://www.marketmapmuse.com/MuseJS/muse.min.js',
  },
];

export enum ViewUris {
  'clientUniverse' = 'client_universe',
  'loanUniverse' = 'loan_universe',
  'rcmCreditDashboard' = 'rcm_credit_dashboard',
  'creditDashboard' = 'creditDashboard',
  'dealsBlotter' = 'deal_pipeline',
  'orderTradeBlotter' = 'order_blotter',
  'rcmPortfolioDashboard' = 'portfolio_positions',
  'hypoBlotter' = 'hypo_blotter',
}

export enum ClientRegion {
  'BrowserRightRegion' = 'BrowserRightRegion',
}
export enum DISPLAY_VIEW {
  CREDIT = 'credit_dashboard',
  ORDER = 'order_blotter',
  DEALS = 'deal_pipeline',
  HYPOS = 'hypo_order_blotter',
  INSTRUMENT = 'instrument',
  ORDER_INSTRUMENT = 'order_instrument',
}

/**
 * Enter all the toolbar icon names over here in the order in which we want to display them
 */
export const TOOLBAR_BEFORE_ICONS_ORDER = ['portfolioManagerButton', 'filterButton', 'Title'];
export const TOOLBAR_AFTER_ICONS_ORDER = [
  'groupPanel',
  'searchButton',
  'searchPanel',
  'switchComponent',
  'refreshButton',
  'modellingButton',
  'portfolioOrderDropdownBtn',
  'portfolioAddDropdownBtn',
  'portfolioProposedOrderButton',
  'exportButton',
  'layoutDropdown',
  'dealsAddItemButton',
  'selectCartComponent',
  'columnManagementButton',
  'columnChooserButton',
  'closeButton',
];
export const DEFAULT_TOOLBAR_ICONS_ORDER = [...TOOLBAR_BEFORE_ICONS_ORDER, ...TOOLBAR_AFTER_ICONS_ORDER];
export enum OBJECT_TYPES {
  CREDIT_DETAILS = 'credit_details',
}
export const BreadCrumbs: { [key: string]: any } = {
  credit_details: {
    previousLink: 'dealsDetailInspector',
    currentLink: 'creditDetailsInspector',
  },
};
export const ImportInstrumentsOverlayTitle = 'Import Instruments Messages';

export const BreadCrumbsWithIssuer: { [key: string]: any } = {
  credit_details: {
    previousLink: 'issuerDetailsInspector',
    currentLink: 'creditDetailsInspector',
  },
};
export const LivePricingToggles: IMarketmapConsumerViewState = { assets: true, portfolio: true };

export enum ImportInstrumentResultTypes {
  COMPLETED = 'Completed',
  PARTIALLY_COMPLETED = 'PartiallyCompleted',
  FAILED = 'Failed',
}
